import { baseCaptcha } from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例

// export function getVerifyPic(data) {
//   return captchaHttp.request<{ bgImage: string; blockImage: string; id: string }>({ url: '/', method: 'POST', data }, { isTransformResponse: false });
// }

// export function verify(id, data) {
//   return captchaHttp.request<boolean>({ url: `/${id}/check`, method: 'POST', data }, { isTransformResponse: false });
// }
const captcha = {
  getVerifyPic(params) {
    return axios.post(`${baseCaptcha()}/captcha/u8R0lIL7gz`, params);
  },
  verify(id, params) {
    return axios.post(`${baseCaptcha()}/captcha/${id}/s5UEAm`, params);
  },
};

export default captcha;
